// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"xi_a bhi_a bhi_x","StrollerDetailRating__muted":"xi_b bhi_fm"};